import { render, staticRenderFns } from "./CampaignTeacherDetailTable.vue?vue&type=template&id=b12819a8&"
import script from "./CampaignTeacherDetailTable.vue?vue&type=script&lang=js&"
export * from "./CampaignTeacherDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports